<mat-card-content class="w-100-p mb-0" (click)="openApprovalRequestTeamRequestsPage()">
    <div class="p-24 stats-wrapper">
        <div fxLayout="column" class="chart-wrapper w-100-p">
            <div fxLayout="row" fxLayoutAlign="space-between center" class="chart-title-wrapper mb-8 w-100-p">
                <div class="w-100-p" fxLayoutAlign="space-between center">
                    <div fxLayout="row">
                        <div fxLayoutAlign="center center" class="icon-wrapper mr-8">
                            <mat-icon svgIcon="approval_request_color"></mat-icon>
                        </div>
                        <label fxLayout="row" fxLayoutAlign="flex-start center" class="chart-title" tabindex="0">
                            {{ 'NAV.TRAINING_APPROVAL_REQUESTS.TITLE' | translate }}
                        </label>
                    </div>
                    <div fxLayoutAlign="flex-end center">
                        <mat-icon svgIcon="right_arrow"></mat-icon>
                    </div>
                </div>
            </div>

            <div fxLayout="row" fxLayoutAlign="center center" fxFlex="1 1 auto" class="bg-zinc-50 text-xs leading-5 min-w-2 text-gray-600 text-center tracking-widest uppercase">
                <span tabindex="0">{{ approvalRequestsTeamOverview?.inProgressRequests }}&nbsp;</span>
                <span>{{ 'TRAINING_APPROVAL_REQUEST.LABEL.OPEN_REQUESTS' | translate }}</span>
            </div>
        </div>
    </div>
</mat-card-content>
